<template>
  <div id="contact-delete" class="row">
    <div class="small-12 medium-8 columns">
      <div class="large warning callout">Are you sure you want to delete contact <em>{{ id }}</em>?</div>
      <div class="button-group expanded">
        <button @click.prevent.stop="cancelForm()" class="success button">{{ 'No, cancel'|t }}</button>
        <button @click.prevent.stop="submitForm()" class="alert button">{{ 'Yes, delete'|t }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'DeleteForm',
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    methods: {
      submitForm() {
        api.deleteContact(
          { contact_id: this.id },
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Contact %s has been deleted.",
              args: [data.contact_id]
            }, {root: true});
            router.push({name: 'contact.collection'});
          }
        );
      },
      cancelForm() {
        router.push({name: 'contact.collection'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/contact/DeleteForm.vue